<div class="complaint-survey" *ngIf="!submissionSuccess && (!submissionOnceCompleted || previewMode)">
    <div class="complaint-survey__form">
        <div class="preview-mode-notice" *ngIf="previewMode">
            <h4>{{ 'COMPLAINT|Podgląd ankiety' | translate }}</h4>
            <p>{{ 'COMPLAINT|Poniżej znajdują się odpowiedzi klienta na pytania ankiety.' | translate }}</p>
        </div>

        <div class="complaint-survey__form__title">{{ complaintSurvey.title }}</div>

        <div *ngIf="complaintSurvey.headerText" class="complaint-survey__form__header-text">
            <p>{{ complaintSurvey.headerText }}</p>
        </div>

        <form [formGroup]="surveyForm" (ngSubmit)="submitSurvey()">
            <div class="complaint-survey__form__questions" formArrayName="responses">
                <div class="complaint-survey__form__questions__question" 
                    *ngFor="let responseControl of getResponseControls(); let i = index"
                    [formGroupName]="i">

                    <div class="complaint-survey__form__questions__question-text">
                        {{ i + 1 }}. {{ complaintSurveyQuestions[i].question }}
                    </div>

                    <ng-container *ngIf="responseControl.get('type')?.value === 'text'">
                        <div class="complaint-survey__form__questions__question-input">
                            <icc-input
                                type="text"
                                [size]="'medium'"
                                [required]="false"
                                [placeholder]="previewMode ? '' : 'INTERFACE|Twoja odpowiedź' | translate"
                                [label]="previewMode ? '' : 'INTERFACE|Twoja odpowiedź' | translate"
                                formControlName="textResponse"
                            ></icc-input>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="responseControl.get('type')?.value === 'multiple_choice'" formGroupName="answers">
                        <div class="complaint-survey__form__questions__question-checkbox">
                            <ng-container *ngFor="let answer of getAnswersForQuestion(responseControl.get('questionId')?.value)">
                                <icc-checkbox
                                    [formControlName]="'answer_' + answer.id"
                                >
                                    <span class="answer-text">{{ answer.answerText }}</span>
                                </icc-checkbox>
                            </ng-container>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="responseControl.get('type')?.value === 'single_choice'">
                        <div class="complaint-survey__form__questions__question-radio">
                            <ng-container *ngFor="let answer of getAnswersForQuestion(responseControl.get('questionId')?.value); let answerIndex = index">
                                <icc-radio
                                    [id]="'question_' + responseControl.get('questionId')?.value + '_answer_' + answer.id"
                                    [name]="'question_' + responseControl.get('questionId')?.value"
                                    [value]="answer.id"
                                    (valueChange)="onRadioValueChange(i, $event)"
                                    [checked]="responseControl.get('answerId')?.value === answer.id"
                                    [disabled]="previewMode"
                                >
                                    <span class="answer-text">{{ answer.answerText }}</span>
                                </icc-radio>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div id="form-navigation" *ngIf="!previewMode">
                <button
                    iccButton
                    type="submit"
                    class="complaint-survey__form__button"
                    appearance="primary"
                    [disabled]="submissionError || submitted"
                >
                    {{ 'INTERFACE|Wyślij' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>

<div class="complaint-survey" *ngIf="submissionSuccess">
    <h3>{{ 'COMPLAINT|Ankieta została przesłana' | translate }}</h3>
    <p>{{ 'COMPLAINT|Dziękujemy za wypełnienie ankiety. Twoja ankieta zostanie teraz przekazana do producenta. Możesz teraz bezpiecznie zamknąć tę kartę.' | translate }}</p>
</div>

<div class="complaint-survey" *ngIf="submissionOnceCompleted && !previewMode">
    <h3>{{ 'COMPLAINT|Ankieta została już wypełniona' | translate }}</h3>
    <p>{{ 'COMPLAINT|Twoje odpowiedzi zostały zapisane. Nie można ponownie wypełnić ankiety.' | translate }}</p>
</div>